import css from '@emotion/css'
import throttle from 'lodash.throttle'
import React, { Component } from 'react'

class Smooth extends Component {
    smoothRef = React.createRef()
    translateRef = React.createRef()
    heightRef = React.createRef()

    componentDidMount() {
        this.targetY = 0
        this.currentY = 0

        window.addEventListener(
            'resize',
            throttle(this.handleResize, 100, { leading: false })
        )
        window.addEventListener('scroll', this.handleScroll)

        this.handleResize()
        setTimeout(() => this.handleResize(), 600)

        this.handleRaf()
    }

    setMaxHeight = () => {
        this.translateRef.current.style.transform = `translate3d(0, 0, 0)`
        this.heightRef.current.style.height = `${
            this.smoothRef.current.scrollHeight
        }px`
    }

    setScrollTarget = () => {
        if (!this.tick) {
            this.tick = true
            this.targetY =
                -window.pageYOffset || -document.documentElement.scrollTop
        }
    }

    handleResize = () => {
        this.setMaxHeight()
        this.setScrollTarget()
    }

    handleScroll = () => {
        this.setScrollTarget()
    }

    handleRaf = () => {
        requestAnimationFrame(this.handleRaf)

        this.tick = false
        const delta = (this.targetY - this.currentY) * 0.1

        if (Math.abs(delta) > 0.1) {
            this.currentY += delta

            this.translateRef.current.style.transform = `translate3d(0, ${Math.round(
                this.currentY
            )}px, 0)`
        }
    }

    render() {
        return (
            <>
                <div ref={this.smoothRef} css={smoothClass}>
                    <div ref={this.translateRef} css={translateClass}>
                        {this.props.children}
                    </div>
                </div>
                <div ref={this.heightRef} />
            </>
        )
    }
}

const smoothClass = css`
    height: 100%;
    left: 0;
    overflow: hidden;
    position: fixed;
    top: 0;
    width: 100%;
`

const translateClass = css`
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    will-change: transform;
`

export default Smooth
